import { render, staticRenderFns } from "./ProcurementBadVendorsTable.vue?vue&type=template&id=a71a25e8"
import script from "./ProcurementBadVendorsTable.vue?vue&type=script&lang=js"
export * from "./ProcurementBadVendorsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports